interface ActiveWorklogSummaryInput {
  general_activity?: string | null
  specific_activity?: string | null
  activity_objective?: string | null
}

const clean = (value?: string | null) => String(value ?? '').trim()

export function getActiveWorklogSummary(worklog?: ActiveWorklogSummaryInput | null) {
  const general = clean(worklog?.general_activity)
  const specific = clean(worklog?.specific_activity)
  const objective = clean(worklog?.activity_objective)

  const primary = [general, specific].filter(Boolean).join(' / ') || objective || 'Sin actividad'
  const secondary = objective ? `Objetivo: ${objective}` : ''
  const tooltip = [primary, secondary].filter(Boolean).join(' | ')

  return {
    primary,
    secondary,
    tooltip,
  }
}
